module.exports = __webpack_public_path__ + "img/workplace_hover.0331191e.png";